<template>
  <div v-loading="pageLoading">
    <div>
      <!-- 搜索 -->
      <el-form :inline="true"
               :model="formInline"
               class="demo-form-inline">
        <el-form-item label="平臺">
          <el-select v-model="formInline.appid" placeholder="請選擇平臺">
            <el-option label="android" value="1"></el-option>
            <el-option label="ios" value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="更新類型">
          <el-select v-model="formInline.updateType" placeholder="請選擇更新類型">
            <el-option label="強製更新" value="1"></el-option>
            <el-option label="選擇更新" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button class="btn"
                     @click="loadMsg">搜尋</el-button>
          <el-button type="primary"
                     @click="add">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <template>
        <el-table ref="singleTable"
                  :data="tableData"
                  style="width: 100%"
                  empty-text="暫無記錄"
                  border
                  @sort-change="sort">
            <el-table-column type="index"
                           label="序號"
                           width="80"></el-table-column>
          <el-table-column property="workNo"
                           label="職員編號"
                           width="80"></el-table-column>
            <el-table-column property="name"
                           label="創建人"
                           width="80"></el-table-column>
            <el-table-column property="appid"
                           label="app應用平臺"
                           width="150"></el-table-column>
            <el-table-column property="updateType"
                           label="更新類型"
                           width="150"></el-table-column>
            <el-table-column property="updateVersion"
                           label="更新版本号"
                           width="150"></el-table-column>
            <el-table-column property="updateInfo"
                           label="更新文案"></el-table-column>              
            <el-table-column sortable="custom"
                           property="creationTime"
                           label="創建時間"
                           width="180"></el-table-column>
            <el-table-column sortable="custom"
                           property="turnoverTime"
                           label="更新時間"
                           width="180"></el-table-column>
          
            <el-table-column label="操作"
                           width="250">
                <template slot-scope="scope">
                <el-button size="mini"
                            type="warning"
                            @click="edit(scope.row.id)">編輯</el-button>
                <el-button size="mini"
                            type="danger"
                            @click="del(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
      </template>
        <el-pagination :hide-on-single-page="true"
                     :total="total"
                     layout="prev, pager, next,total"
                     @current-change="pageChange"></el-pagination>
        <!-- 彈窗 -->
      <el-dialog :title="title"
                 :visible.sync="dialogFormVisible"
                 :before-close="dialogClose"
                 width="800px"> 
        <el-form :model="form"> 
          <el-form-item label="版本名" prop="updateVersion">
            <el-input v-model="form.updateVersion" 
              :placeholder="dialogDataLoading ? '加載中' : '例如：1.0.24'"
              :disabled="dialogDataLoading" 
              width="200px"
            ></el-input>
          </el-form-item>

          <el-form-item label="更新平臺" prop="updatePlatform">
            <el-radio v-model="form.appid" :label="1">android</el-radio>
            <el-radio v-model="form.appid" :label="2">ios</el-radio>
          </el-form-item>

          <el-form-item label="是否強製更新" prop="updateType">
            <el-switch v-model="form.updateType" :inactive-value="2" :active-value="1" :disabled="dialogDataLoading"></el-switch>
          </el-form-item>

          <el-form-item label="更新內容" prop="updateInfo">
            <el-input 
              type="textarea" 
              v-model="form.updateInfo" 
              :placeholder="dialogDataLoading ? '加載中' : '請輸入更新日誌'"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="dialogClose">取 消</el-button>
          <el-button type="primary"
                     @click="versionM" :loading="dialogLoading">確 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
var that;
export default {
  data () {
    return {
      pageLoading: false,
      dialogDataLoading: false,
      dialogLoading: false,

      formInline: {
          pageSize: 10,
          pageNum: 1,
          sortAsc: "",
          sortDesc: "creationTime",
          updateVersion:"",
          appid:"",
          updateType:""
      },
      form: {
          updateVersion: "",
          appid: "",
          updateType: 2,
          updateInfo: "",
      },
      title:"",
      tableData: [],
      total: 0,
      dialogFormVisible:false,
      versionId: ''
    };
  },
  mounted () {
    $('#pageHead').text('App版本控製');
  },
  methods: {
    sort (msg) {
      // 排序
      var prop = msg.prop,
        order = msg.order,
        formInline = this.formInline;
      if (order == 'ascending') {
        formInline.sortDesc = prop;
        formInline.sortAsc = '';
      } else {
        formInline.sortDesc = '';
        formInline.sortAsc = prop;
      }
      that.loadMsg();
    },
    add () {
      // 新增
      this.form ={
            updateVersion: "",
            appid: "",
            updateType: 2,
            updateInfo: "",
      };
      this.title = "新增版本";
      this.dialogFormVisible = true;
    },
    loadMsg () {
      this.pageLoading = true
      var msg = this.utils.filtration(that.formInline);
      this.axios({
        url: '/manage/getAppVersionControlList',
        params: msg
      }).then(res => {
        this.pageLoading = false
        if (res) {
          this.total = res.total;
          this.tableData = res.result;
        }
      })
    },
    versionM(){
      var msg = this.form;
      if (msg.updateVersion == '') {
        this.$message({
          type: 'warning',
          message: '請填寫版本信息'
        });
        return;
      }
      if (msg.appid == '') {
        this.$message({
          type: 'warning',
          message: '請選擇平臺類型'
        });
        return;
      }
      if (msg.updateType == '') {
        this.$message({
          type: 'warning',
          message: '請選擇更新類型'
        });
        return;
      }
      this.dialogLoading = true
      if (this.title === '新增版本') {
        this.axios({
          url: '/manage/addAppVersionControl',
          params: msg,
          method: 'post',
        }).then(res => {
          if (res) {
            that.$message({
              type: 'success',
              message: '新增成功!'
            });
          }
          this.loadMsg();
          this.dialogLoading = false
          this.dialogFormVisible = false;
          // 清空form
          this.form = {
            updateVersion: "",
            appid: "",
            updateType: 2,
            updateInfo: "",
          }
        }).catch(() => {
          this.dialogLoading = false
        })
      }
      if (this.title === '修改版本') {
        msg.id = this.versionId;
        this.axios({
          url: '/manage/updateAppVersionControl',
          params: msg,
          method: 'post',
        }).then(res => {
          if (res) {
            this.$message({
              type: 'success',
              message: '更新成功!'
            });
          }
          this.loadMsg();
          this.dialogLoading = false
          this.dialogFormVisible = false;
          // 清空form
          this.form = {
            updateVersion: "",
            appid: "",
            updateType: 2,
            updateInfo: "",
          }
        }).catch(() => {
          this.dialogLoading = false
        })
      }
      

    },
    edit (id) {
      this.title = '修改版本';
      this.versionId = id;
      this.dialogDataLoading = true
      this.axios({
        url: '/manage/getAppVersion',
        params: {
          id: id
        }
      }).then(res => {
        if (res) {
          var msg = res.result;
          this.form.updateVersion = msg.updateVersion;
          this.form.appid = msg.appid;
          this.form.updateType = msg.updateType;
          this.form.updateInfo = msg.updateInfo;
        }
        this.dialogDataLoading = false
      })
      this.dialogFormVisible = true;
    },
    del (id) {
      this.$confirm('確認刪除該條版本信息？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '確定',
        type: 'warning'
      })
        .then(() => {
          this.axios({ url: "/manage/delAppVersionControl", params: { id }, method: 'post' }).then((res) => {
            if (res) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.loadMsg()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    pageChange (val) {
      this.formInline.pageNum = val
      this.loadMsg()
    },
    // 弹窗关闭
    dialogClose(done) {
      this.dialogFormVisible = false
      this.form = {
        updateVersion: "",
        appid: "",
        updateType: 2,
        updateInfo: "",
      }
      if (done) {
        done()
      }
    }
  },
  created () {
    that = this;
    this.loadMsg();
  }
};
</script>

<style scoped>
.btn {
  margin-left: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
}
.el-form-item .el-form-item__content .el-checkbox-group .el-checkbox {
  margin-left: 0px;
}
</style>
